import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import ClientInfo from '../Clients/ClientInfo';
import {
  GetClientDto,
  GetPurchaserDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { ClientSelector } from '../Selects/ClientSelector';
import { Option } from '../Selects/Selector';

interface SalesInvoiceClientEditorProps {
  purchaser?: GetPurchaserDto;
  recipientClient?: GetClientDto;
  recipientClientId?: string | null;
  readOnly?: boolean;
  onRecipientClientChange?: (id: string | null) => void;
}

export const SalesInvoiceClientEditor: React.FC<
  SalesInvoiceClientEditorProps
> = props => {
  const { t, tk } = useTranslation('fvsLng');

  const handleRecipientChange = (option: Option) => {
    props.onRecipientClientChange?.(option?.value ?? null);
  };

  return (
    <>
      <FormRow controlId="client" label={t(tk.common.contractor)}>
        <div className="d-flex">
          <div className="flex-grow-1">
            <Form.Control
              type="text"
              value={`${props.purchaser?.client?.name || ''} ${props.purchaser?.client?.nip ? '(' + t(tk.finance.nip) + ': ' + props.purchaser?.client?.nip + ')' : ''}`}
              disabled
            />
          </div>
          <div className="flex-grow-0">
            <ClientInfo
              id={props.purchaser?.client.id}
              className="color-primary ms-2 mt-2"
              iconSize={20}
              placement="left"
            />
          </div>
        </div>
      </FormRow>
      {/* <FormRow controlId="nip" label={t(tk.finance.nip)}>
        <Form.Control
          type="text"
          value={props.purchaser?.client?.nip || ''}
          disabled
        />
      </FormRow> */}

      {process.env.REACT_APP_RECIPIENT?.toLocaleLowerCase() === 'on' &&
        (!props.readOnly || props.recipientClientId) && (
          <FormRow controlId="recipientClient" label={t(tk.common.recipient)}>
            <div className="d-flex">
              <div className="flex-grow-1">
                <ClientSelector
                  valueId={props.recipientClientId ?? undefined}
                  readOnly={props.readOnly}
                  clearable={true}
                  buildName={client =>
                    `${client.name}${client.nip ? ' (' + t(tk.finance.nip) + ': ' + client.nip + ')' : ''}`
                  }
                  onChange={handleRecipientChange}
                />
              </div>
              {props.recipientClientId && (
                <div className="flex-grow-0">
                  <ClientInfo
                    id={props.recipientClientId ?? undefined}
                    className="color-primary ms-2 mt-2"
                    iconSize={20}
                    placement="left"
                  />
                </div>
              )}
            </div>
          </FormRow>
        )}
    </>
  );
};
